export default __webpack_public_path__ + "static/media/Version (1) - Early Prop_09.e3563bc4.jpg";